import { processRecursive } from '../../utils/generalUtils';
import dataFieldUtils from '../../utils/dataFieldUtils';
import gridViewFieldsUtils from '../../utils/gridViewFieldsUtils';

export default {
	data() {
		return {
			checkReferenceFields_showDialog: false,
			checkReferenceField_referenceField: null,
		};
	},
	computed: {
		referenceFields() {
			let reffs = [];
			if (!this.formFields) return reffs;
			this.formFields.forEach((ff) => {
				if (ff.GridViewFields && ff.GridViewFields.length > 0) {
					ff.GridViewFields.forEach((gvf) => {
						if (gvf.ReferenceListTypeId) {
							reffs.push({
								ReferenceListTypeId: gvf.ReferenceListTypeId,
								ReferenceListType: gvf.ReferenceListType,
								FormField: ff,
								IdKey: dataFieldUtils.getDataFieldName(
									gvf.DataField
								),
							});
						}
					});
				}
			});
			return reffs;
		},
	},
	methods: {
		getFormFieldRecordValue(formField) {
			if (!formField) return null;
			if (!formField.GridViewFields) return null;
			if (formField.GridViewFields.length === 1) {
				let key = gridViewFieldsUtils.getFieldName(
					formField.GridViewFields[0]
				);
				return this.record[key];
			}
			return null;
		},

		buildReferenceCheckList() {
			let list = [];
			this.referenceFields.forEach((r) => {
				let value = this.getFormFieldRecordValue(r.FormField);
				if (value) {
					list.push(JSON.parse(JSON.stringify(r)));
				}
			});
			return list;
		},

		checkReferenceFields() {
			return new Promise((resolve) => {
				if (!this.referenceFields) resolve(true);
				if (this.referenceFields.length <= 0) resolve(true);
				let reffs = this.buildReferenceCheckList();
				if (reffs.length <= 0) resolve(true);
				processRecursive(reffs, this.checkReferenceField).then(
					(success) => {
						if (!success) resolve(false);
						resolve(true);
					}
				);
			});
		},

		checkReferenceField(reff) {
			return new Promise((resolve) => {
				let idKey = reff.IdKey;
				if (
					idKey &&
					this.record[idKey] &&
					(this.record[idKey] || this.record[idKey] === -1)
				) {
					resolve(true);
				} else {
					this.checkReferenceFields_showDialog = true;
					this.checkReferenceField_referenceField = reff;
					resolve(false);
				}
			});
		},

		onCheckReferenceFieldsModalClose() {
			this.checkReferenceFields_showDialog = false;
			this.checkReferenceField_referenceField = null;
		},
		async onCheckReferenceFieldsModalSubmit() {
			this.onCheckReferenceFieldsModalClose();
			await this.onSave();
		},
	},
};
